var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTickLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72392 17.9089L8.52392 24.7199C8.88692 25.1549 9.36692 25.4809 9.90492 25.6569C10.6999 25.9069 11.7999 25.8899 12.7439 24.5429L25.6989 4.34391C25.7949 4.19491 25.8689 4.03191 25.9179 3.86391C26.1099 3.20391 26.0689 1.75491 24.6309 2.33391C24.2319 2.49691 23.8789 2.75891 23.6079 3.09291L11.3979 17.7869C10.9299 18.3509 10.0939 18.4279 9.52892 17.9599C9.47592 17.9169 9.42592 17.8689 9.37992 17.8159L6.65392 14.7179C6.10192 14.0739 5.31092 13.6829 4.46392 13.6299C3.54892 13.5919 2.49192 13.8609 2.10492 15.1959C1.84492 16.1489 2.07592 17.1639 2.72392 17.9089Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickLine);
export default __webpack_public_path__ + "static/media/icon-tick-line.779fc56c65963a1b1ee770325ca28041.svg";
export { ForwardRef as ReactComponent };